// eslint-disable-next-line no-unused-vars
import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react'
import { capitalizeFLetter, confirmation_modal, clipboard, fetchApiData, loadAccount, fetchItems, loadMinSellingPrices, update_product_graph, roundPrice } from '../fnc.js'
import PMAHeaderInfoResult from './ctn/pma/PMAHeaderInfoResult.js'
import Loading from '../Pages/ctn/Loading';
import Pagination from './ctn/eBay/Pagination.js'
import moment from 'moment';
import $ from 'jquery';
import logoStoreEio from '../img/fav-trans-eio-border.png';
import logoStoreHaus from '../img/fav-trans-hausOfTools.png';
import logoStoreEbay from '../img/ebay_circle_perso.png';
import logoStoreEbayYWE from '../img/ebay_circle_YWE_perso_2.png';
import logoStoreWalmart from '../img/walmart_circle_updated.png';
import logoStoreAmazon from '../img/amazon_circle_perso.png';
import logoStoreAmazonGott from '../img/amazon_circle_perso_gott_v2.png';
import ExcelJS from 'exceljs';

const refConst = require("../constants.js").v

const initialState = {
	accountAccepted: false,
	products: {},
	pmaData: [],
	pmaStores: [],
	currentAccountLines: [],
	lineAccess: {from: null, to: null},
	dataNumber: null,
	dataNumberFilled: null,
	pma: null
}

export default function PMA(props){

	const adminAccess = [
		"-MjVxK86GVBUKL5oNU66", // General admin
		"-ON1qrQ9xBbT0EbKFaTH", // PMA admin
	]

	const ourStores = [
		refConst.id_store_eio,
		refConst.id_store_hausfTools,
		refConst.id_store_eBay_EIO,
		refConst.id_store_eBay_YWE,
		refConst.id_store_amazon_EIO,
		refConst.id_store_amazon_GOTT,
		refConst.id_store_walmart_eio,
	]

	const storeIconsPerId = {
		[refConst.id_store_eio]: logoStoreEio,
		[refConst.id_store_hausfTools]: logoStoreHaus,
		[refConst.id_store_eBay_EIO]: logoStoreEbay,
		[refConst.id_store_eBay_YWE]: logoStoreEbayYWE,
		[refConst.id_store_amazon_EIO]: logoStoreAmazon,
		[refConst.id_store_amazon_GOTT]: logoStoreAmazonGott,
		[refConst.id_store_walmart_eio]: logoStoreWalmart,
	}

	if(!props.securityClearance(props))	return;

	console.info("sadsadsadsad", props.getUser());
	const qtyPerPage = 500;
	const [version] = useState("0.1.0");
	const [pmaData, setPmaData] = useState(initialState.pmaData);
	const [accountAccepted, setAccountAccepted] = useState(initialState.accountAccepted);
	// const [currentAccountLines, setCurrentAccountLines] = useState(initialState.currentAccountLines);
	const [lineAccess, setLineAccess] = useState(initialState.lineAccess);
	const [products, setProducts] = useState(initialState.products);
	const [pmaStores, setPmaStores] = useState(initialState.pmaStores);
	const [refreshWindow, setRefreshWindow] = useState(0);
	const [dataNumber, setDataNumber] = useState(initialState.dataNumber);
	const [dataNumberFilled, setDataNumberFilled] = useState(initialState.dataNumberFilled);
	const [page, setPage] = useState(0);
	const [pma, setPma] = useState(initialState.pma);
	const [isDataLoading, setIsDataLoading] = useState(true);
	const [stores, setStores] = useState([]);
	var prevPmaDataReloadData = useRef(null);

	useEffect(() => {
		$('.tooltipInfo').tooltip({
			placement: "right",
			template:  '<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner tooltip-info-ebay"></div></div>',
		}).tooltip('update')

		$('.tooltipInfo').on('click', function() {
			$('.tooltip').tooltip('hide');
		});
	})

	const newColorPerStoreId = {
		[refConst.id_store_eio]: "f7ceac",
		[refConst.id_store_hausfTools]: "f4f7ac",
		[refConst.id_store_eBay_EIO]: "acf7e8",
		[refConst.id_store_eBay_YWE]: "acccf7",
		[refConst.id_store_amazon_EIO]: "e4acf7",
		[refConst.id_store_amazon_GOTT]: "f7deac",
		[refConst.id_store_walmart_eio]: "f27ff4",
	}
	
	useEffect(() => {
		// Calculate dynamic height for pmaTable by subtracting navbar and infoBox heights
		const calculateTableHeight = () => {
			const windowHeight = window.innerHeight;
			const navbarHeight = document.querySelector('.navbar')?.offsetHeight || 0;
			const infoBoxHeight = document.querySelector('.infoBox')?.offsetHeight || 0;
			const tableHeight = windowHeight - navbarHeight - infoBoxHeight - 90; // 20px buffer
			
			const pmaTable = document.querySelector('.pmaTable');
			if (pmaTable) {
				pmaTable.style.height = `${tableHeight}px`;
			}
		}

		// Calculate on mount and window resize
		calculateTableHeight();
		window.addEventListener('resize', calculateTableHeight);

		// Cleanup
		return () => {
			window.removeEventListener('resize', calculateTableHeight);
		}
	})

	useEffect(() => {
		// Synchronize row heights between sticky and main tables
		const syncRowHeights = () => {
			const table = document.querySelector('.pmaTable');
			if (!table) return;

			const stickyRows = table.querySelectorAll('.sticky-row');
			const mainRows = table.querySelectorAll('.main-row');
			
			// Match each sticky row height to its corresponding main row.
			stickyRows.forEach((stickyRow, index) => {
				const mainRow = mainRows[index];
				if (mainRow) {
					// Clear the previous value before measuring in case the row became shorter.
					stickyRow.style.height = '';
					stickyRow.style.transform = '';
					stickyRow.style.height = `${mainRow.getBoundingClientRect().height}px`;
				}
			});

			// Correct any sub-pixel/border rounding per row. Applying the correction
			// to each row prevents a small difference from accumulating into a gap.
			stickyRows.forEach((stickyRow, index) => {
				const mainRow = mainRows[index];
				if (mainRow) {
					const offset = mainRow.getBoundingClientRect().top - stickyRow.getBoundingClientRect().top;
					stickyRow.style.transform = `translateY(${offset}px)`;
				}
			});
		}

		let resizeObserver;
		let frameId;
		const scheduleSync = () => {
			cancelAnimationFrame(frameId);
			frameId = requestAnimationFrame(syncRowHeights);
		};

		// Sync once after rendering, then keep the rows aligned if their content changes.
		if (pmaData.length > 0) {
			scheduleSync();
			const mainRows = document.querySelectorAll('.pmaTable .main-row');
			if (typeof ResizeObserver !== 'undefined') {
				resizeObserver = new ResizeObserver(scheduleSync);
				mainRows.forEach(row => resizeObserver.observe(row));
			}
		}

		window.addEventListener('resize', scheduleSync);
		
		return () => {
			window.removeEventListener('resize', scheduleSync);
			cancelAnimationFrame(frameId);
			resizeObserver?.disconnect();
		}
	}, [pmaData])

	useEffect(() => {
		if(!props.parent.match.params.idPma)	return;
		setIsDataLoading(true);
		setPmaData([]);
		fetchPMAStores();
		getPMADataCount();
		getPMADataFilledCount();
		getPma();
	}, [props.parent.match.params.idPma])

	useEffect(() => {
		if(!refConst.stores || !refConst.stores.length)	return;
		// only keep what we want and sort it like ourStores
		let ourStoresId = [];
		ourStores.forEach(s => {
			let found = refConst.stores.find(st => st.id === s)
			if(!found)	return;
			ourStoresId.push(found);
		})
		setStores(ourStoresId)
	}, [refConst.stores])

	useEffect(() => {
		if(props.accounts && props.accounts.length > 0 && props.parent.match.params.idPma){
			fetchPMAAccount();
		}
	}, [props.accounts, props.parent.match.params.idPma])

	/* useEffect(() => {
		if(pmaData.length > 0){
			fetchItemsFinale((listPerId) => {
				addMinSellingPrices(listPerId, (listPerId) => {
					console.info("listPerIdlistPerIdlistPerId", listPerId);
					setProducts(listPerId);
				});
			});
		}
	}, [pmaData]) */

	useEffect(() => {
		// if there is a limit of line available for this user, we remove the unnecessary data from the pmaData

		if(JSON.stringify(prevPmaDataReloadData.current) != JSON.stringify([lineAccess, page])){
			prevPmaDataReloadData.current = [lineAccess, page];
			getPmaData(true);
		}

	}, [lineAccess, page])

	let getPmaData = (onlyFilled) => {
		setIsDataLoading(true);
		fetchApiData("eio", "getPMAData_multi", {
			filters: JSON.stringify({
				id_pma: props.parent.match.params.idPma,
				from: parseInt(page) * parseInt(qtyPerPage),
				count: parseInt(qtyPerPage),
				onlyFilled: onlyFilled
			})
		}, null, (r) => {
			console.info("getPMAData_multi", r);
			console.info("getPMAData2", lineAccess);
			const data = r.data ?? [];
			data.forEach(d => {
				d.priceSaved = {};
				d.qtySaved = {};
				d.minDataAdded = [];
			})
			if(lineAccess.from !== null && lineAccess.to !== null){
				setPmaData(data.length > 0? data.slice(lineAccess.from, lineAccess.to) : []);
			}else{
				setPmaData(data);
			}
			setIsDataLoading(false);
		})
	}


	let isAdmin = () => {
		let permissions = props.getUser().permissions;
		if(!permissions || !adminAccess)	return false;
		return permissions.some(p => adminAccess.indexOf(p) !== -1);
	}

	let getPma = () => {
		fetchApiData("eio", "getPMA", {
			filters: JSON.stringify({
				id: props.parent.match.params.idPma
			})
		}, null, (r) => {
			console.info("getPMA", r);
			setPma(r.data && r.data.length > 0? r.data[0] : null);
		})
	}

	let updateFinale = (sku, otherProps, callback) => {
		if(!sku)	return;
		update_product_graph([{
			"Product ID": sku,
			...otherProps
		}], (r) => {
			console.info("updateFinale", r);
			if(r.errors){
				props.info({error: r.errors});
			}else if(r.success){
				setRefreshWindow(refreshWindow + 1);
				if(callback)
					callback(r);
			}
		})
	}

	let addMinSellingPrices = (productsList, callback) => {
		let args = [];

		pmaData.forEach(d => {
			args.push({
				sku: productsList[d.id_product]?.sku,
				weight: d.static_weight,
				weight_unit: d.static_weight_unit,
				cost: d.static_cost
			})
		})

		loadMinSellingPrices(args, (dr) => {
			console.info("addMinSellingPrices", dr);
			let d = dr.data;
			for (const key in productsList) {
				if (Object.prototype.hasOwnProperty.call(productsList, key)) {
					productsList[key].minPriceData = d.find(d => d.sku === productsList[key].sku)
				}
			}
			if(callback)
				callback(productsList);
		})
	}

	let fetchPMAAccount = () => {
		fetchApiData("eio", "getPMAAssignedAccount", {
			filters: JSON.stringify({
				'id_pma': props.parent.match.params.idPma
			})
		}, null, (r) => {
			console.log("PMA_assigned_to_accounts", r)
			if(r.data.length > 0){
				// Merge the accounts with the accounts from the props
				let accAccepted = props.accounts.filter(account => r.data.some(assignedAccount => assignedAccount.id_account === account.id));
				setAccountAccepted(accAccepted);
				console.info("accountsAcceptedaccountsAccepted", accAccepted);
				console.info("accountsAcceptedaccountsAccepted22", props.getUser().id);
				let currUserId = props.getUser().id;
				// currUserId = 230
				let findAccAccess = r.data.filter(d => d.id_account === currUserId)
				//setCurrentAccountLines(findAccAccess.length > 0? findAccAccess[0] : []);
				setLineAccess(findAccAccess.length > 0? {
					from: findAccAccess[0].line_from,
					to: findAccAccess[0].line_to
				} : {from: null, to: null}); // We can change the value here to test the access
			}else{
				setLineAccess({from: null, to: null});
				setAccountAccepted([]);
			}refConst
		})
	}

	let fetchItemsFinale = (callback) => {
		fetchItems("eio", {
			"idProductList": pmaData.map(item => item.id_product).join(",")
		}, (r) => {
			console.info("fetchItemsFinale", r);
			if(r.error){
				props.info({error: r.error});
				setProducts({});
			}else{
				let listPerId = {}
				r.data.some(o => {
					listPerId[String(o.id)] = o;
				})
				if(callback)
					callback(listPerId);
				else
					setProducts(listPerId);
			}
		})
	}

	let getPMADataCount = () => {
		fetchApiData("eio", "getPMADataCount", {
			id_pma: props.parent.match.params.idPma
		}, null, (r) => {
			console.info("getPMADataCount", r);
			setDataNumber(r.count);
		})
	}
	let getPMADataFilledCount = () => {
		fetchApiData("eio", "getPMADataFilledCount", {
			id_pma: props.parent.match.params.idPma
		}, null, (r) => {
			console.info("getPMADataFilledCount", r);
			setDataNumberFilled(r.count);
		})
	}

	let fetchPMAStores = () => {
		fetchApiData("eio", "getPMAStores", {
			filters: JSON.stringify({
				'id_pma': props.parent.match.params.idPma
			})
		}, null, (r) => {
			console.info("fetchPMAStores", r);
			r.data.sort((a, b) => a.id - b.id);
			setPmaStores(r.data?? []);
		})
	}

	let getPmaStoreFromId = (id_pma_stores) => {
		if(id_pma_stores){
			let stF2 = pmaStores.find(s => s.id === id_pma_stores)
			return stF2
		}
		return null;
	}

	let calculateSuggestedPrice = (inputPrice, minPrice, prcDown = 0, store) => {
		const price = Number(inputPrice) || 0;
		const min = Number(minPrice);
		if (price <= 0) return null;

		// We return the minimum price if the price is lower than the minimum price
		if (Number.isFinite(min)) {
			if (price <= min) {
				store.decidedBy = store.decidedBy?.includes("lookout")
					? store.decidedBy + " - rized to min"
					: "min";
				return min;
			}
			const suggested = price * (100 - prcDown) / 100;
			return suggested >= min ? suggested : (store.decidedBy = "min", min);
		}
		// No valid min available; return discounted anchor
		return price * (100 - prcDown) / 100;
	}

	let submitMainData = (data, callback) => {

		fetchApiData("eio", "setPMADataStoreInfo", {
			'data': JSON.stringify(data)
		}, null, (r) => {
			console.log("setPMADataStoreInfo", r)
			if(callback)
				callback(r);
		})
	}

	let resetPage = () => {
		for (const key in initialState) {
			if (initialState.hasOwnProperty(key)) {
				// const element = initialState[key];
				let val = JSON.parse(JSON.stringify(initialState[key]))
				console.info('Eval result', eval("set" + capitalizeFLetter(key))(val));
			}
		}
	}


	let isAuthorized = () => {
		if(isAdmin())	return true;	
		if(!accountAccepted || accountAccepted.length === 0)	return false;
		let found = accountAccepted.find(account => account.id === props.getUser().id);
		return found !== undefined;
	}

	let logicCalculation = (callback, callback2) => {

		/**
		 *  Rules:
		 *   - Make a list of all prices found for each filled stores from pmaData[x].price_list
		 * 
		 * We get the min list per store in pmaData[x].minDataAdded[x]
		 */

		console.info("pmaDatapmaDatapmaDatapmaData", pmaData);
		return pmaData.map((d, index) => {

			/* console.info("dddddd", d);
			console.info("dddddd2 - d.stores", d.stores);
			console.info("dddddd3 - stores", stores);
			console.info("dddddd4Product - products[d.id_product]", products[d.id_product]); */

			//! Calculation
			let minListPerStore = []
			if(!d.avgMin || !d.maxMin){
				if(d.minDataAdded.length === 0){
					let val = products[String(d.id_product)]?.minPriceData?.minSellingPrice
					console.info("valvalvalval", val);
					if(val){
						for (const idStore in val) {
							if (Object.prototype.hasOwnProperty.call(val, idStore)) {
								minListPerStore.push({
									storeId: idStore,
									min: val[idStore],
									icon: storeIconsPerId[idStore]
								})
							}
						}
						if(minListPerStore.length > 0){
							d.minDataAdded = minListPerStore;
						}
						val = Object.values(val)
						d.avgMin = (val.reduce((acc, val) => acc + val, 0) / (val.length || 1))
						d.maxMin = Math.max(...val);
					}
				}
			}

			//  All our stores
			let cpStores = JSON.parse(JSON.stringify(stores));

			if(products[d.id_product]?.sku == "PYR-GL3010CKX2"){
				
				console.info("cpStores222", cpStores);
				console.info("cpStores2223333", d.stores);
			}

			d.stores = d.stores.filter(st => {
				if("price" in st)
					return st;
			})

			// Add the price info to each store if a value exist
			cpStores.forEach(st => {
				if("storeInfo" in st)
					return;
				st.hasSpecialLookout = null;
				st.storeInfo = null;
				d.stores.forEach(st2 => {
					if(st2.id_store_associated == st.id){
						st.storeInfo = st2;
					}
				})
			})

			d.stores.forEach(st => {
				// Find the PMA store data like the name from the id matching
				let storeData = getPmaStoreFromId(st.id_pma_stores);

				if(storeData){
					storeData.lookout_by = !Array.isArray(storeData?.lookout_by)? storeData?.lookout_by?.split(",") : storeData?.lookout_by;
					st.pmaStore = storeData;

					if(storeData.lookout_by){
						// find each stores in the lookup and add the data to look for
						cpStores.some((st2, posT) => {
							st2.hasSpecialLookout = false;
							if(storeData.lookout_by && storeData.lookout_by.includes(String(st2.id))){
								// alert(st.price + " " + posT)
								// Make a list of all stores looked after so that we can have a special calculation for each of them
								st2.hasSpecialLookout = true;
								if(!("lookoutForInfo" in st2))
									st2.lookoutForInfo = [];
								st2.lookoutForInfo.push(st)
							}
						})
					}
				}
			})

			// At this point we all the data we need for all calculations

			// Loop through all out stores and calculate the recommended price for each of them with details on why this price was chosen
			let listTdStores = [];
			cpStores.some((store, pos) => {

				// Find filled price data from d.stores
				let filledStoreInfo = d.stores?.find(st => {
					return st.id_store_associated_ids?.includes(store.id.toString()) || 
						st.id_pma_stores === store.id;
				});

				// Find recommended data from d.recommended
				let recommendedData = d.recommended?.find(rec => rec.id_store === store.id);

				let borderColor = null;
				let color = null;
				let recommendedPrice = null;
				let prcDiff = null;
				let price = 0.0;
				let pricerSelected = null;

				// Get filled price from stores data
				if(filledStoreInfo && filledStoreInfo.price && filledStoreInfo.price > 0){
					price = filledStoreInfo.price;
				}

				// Get recommended price from recommended data
				if(recommendedData && recommendedData.recommended_price && recommendedData.recommended_price > 0){
					recommendedPrice = recommendedData.recommended_price;
					pricerSelected = recommendedData.recommended_price;
				}

				// Get min selling price
				let ourMin = null;
				if(recommendedData && recommendedData.min_selling_price){
					ourMin = recommendedData.min_selling_price;
				} else if(d.minSellingPrice && d.minSellingPrice[store.id]){
					ourMin = d.minSellingPrice[store.id];
				} else if(d.calculated_min_selling_price){
					ourMin = d.calculated_min_selling_price;
				}

				// Calculate price difference
				if(pricerSelected && ourMin && ourMin > 0){
					prcDiff = ((pricerSelected - ourMin) / ourMin * 100).toFixed(2);
				}

				// Set color based on price comparison
				if(pricerSelected && ourMin){
					color = pricerSelected > ourMin ? "success" : "danger";
				}

				// Set decided by logic
				if(recommendedData && recommendedData.competitor_price){
					store.decidedBy = "competitor match";
				} else if(filledStoreInfo && filledStoreInfo.price){
					store.decidedBy = "filled price";
				} else if(recommendedPrice){
					store.decidedBy = "recommended";
				} else {
					store.decidedBy = "no data";
				}

				let noPriceFound = !price && !recommendedPrice;
				let highestWanted = recommendedPrice || price || 0;

				listTdStores.push(callback(store, price, pricerSelected, recommendedPrice, prcDiff, color, borderColor, noPriceFound, ourMin, highestWanted, filledStoreInfo, d));
			})
			return callback2(index, d, listTdStores);
		})
	}

	let dlDetails = async () => {
		try{
			props.loading(true);

			// Fetch ALL data without pagination for export
			const fetchAllData = () => {
				return new Promise((resolve, reject) => {
					fetchApiData("eio", "getPMAData_multi", {
						filters: JSON.stringify({
							id_pma: props.parent.match.params.idPma,
							from: 0,
							count: 999999, // Large number to get all records
							onlyFilled: true
						})
					}, null, (r) => {
						if (r.data) {
							resolve(r.data);
						} else {
							reject(new Error("Failed to fetch data"));
						}
					});
				});
			};

			// Get all data for export
			const allData = await fetchAllData();

			if(allData.length === 0) {
				props.loading(false);
				props.info({error: "No data to export"});
				return;
			}

			const workbook = new ExcelJS.Workbook();
			
			// Create main report worksheet
			const worksheet = workbook.addWorksheet('PMA Report');
			
			// Create summary worksheet
			const summaryWorksheet = workbook.addWorksheet('Summary');

			// Build comprehensive data structure
			let reportData = [];
			let summaryStats = {
				totalProducts: allData.length,
				productsWithPrices: 0,
				productsNotFound: 0,
				avgRecommendedPrice: 0,
				avgMinSellingPrice: 0,
				storeStats: {}
			};

			// Initialize store stats
			stores.forEach(store => {
				summaryStats.storeStats[store.name] = {
					productsWithPrices: 0,
					avgPrice: 0,
					avgRecommended: 0,
					totalQty: 0
				};
			});

			allData.forEach((d, index) => {
				let productData = {
					// Basic product info
					'ID': d.id,
					'SKU': d?.sku ?? "",
					'Title': d?.title ?? "",
					'UPC/EAN': d?.upc ?? "",
					'ASIN': d?.static_asin ?? "",
					'Supplier ID': d?.id_supplier1 ?? "",
					'Weight (lbs)': d.static_weight ?? d?.weight ?? "",
					'Cost': d.static_cost ?? d.cost ?? "",
					'MSRP': d?.msrp ?? d.msrp ?? "",
					'MAP Price': d?.map_price ?? d.map_price ?? "",
					'Calculated Min Selling Price': d.calculated_min_selling_price ?? "",
					'Google Shipping Cost': d.google_shipping_cost ?? "",
					'Not Found Anywhere': d.not_found_anywhere ? 'Yes' : 'No',
					'Date Created': d.date_created ?? "",
					'Is Filled': d.is_filled ? 'Yes' : 'No',
					'Count Price Filled': d.cnt_price_filled ?? 0
				};

				// Add our store-specific recommended data (grouped by store)
				stores.forEach(store => {
					// Find recommended data for this store
					const recommendedData = d.recommended?.find(rec => rec.id_store === store.id);
					
					// Find competitor price data for this store
					const storeInfo = d.stores?.find(s => {
						return s.id_store_associated_ids?.includes(store.id.toString()) || 
							s.id_pma_stores === store.id;
					});

					// Group all data for this store together
					productData[`${store.name} - Recommended Price`] = recommendedData?.recommended_price ?? "N/A";
					productData[`${store.name} - Min Selling Price`] = recommendedData?.min_selling_price ?? "N/A";
					productData[`${store.name} - Competitor Price`] = recommendedData?.competitor_price ?? storeInfo?.price ?? "N/A";
					productData[`${store.name} - Pack Qty`] = storeInfo?.pack_qty ?? "N/A";
					
					// Update summary stats
					if (recommendedData?.recommended_price && recommendedData.recommended_price > 0) {
						summaryStats.storeStats[store.name].avgRecommended += recommendedData.recommended_price;
					}
					if (storeInfo?.price && storeInfo.price > 0) {
						summaryStats.storeStats[store.name].productsWithPrices++;
						summaryStats.storeStats[store.name].avgPrice += storeInfo.price;
						summaryStats.storeStats[store.name].totalQty += (storeInfo.pack_qty || 0);
					}
				});

				// Update summary stats
				if (d.stores?.some(s => s.price && s.price > 0)) {
					summaryStats.productsWithPrices++;
				}
				if (d.not_found_anywhere) {
					summaryStats.productsNotFound++;
				}
				if (d.calculated_min_selling_price) {
					summaryStats.avgMinSellingPrice += d.calculated_min_selling_price;
				}

				reportData.push(productData);
			});

			// Calculate averages
			summaryStats.avgMinSellingPrice = summaryStats.avgMinSellingPrice / summaryStats.totalProducts;
			Object.keys(summaryStats.storeStats).forEach(storeName => {
				const storeStat = summaryStats.storeStats[storeName];
				if (storeStat.productsWithPrices > 0) {
					storeStat.avgPrice = storeStat.avgPrice / storeStat.productsWithPrices;
					storeStat.avgRecommended = storeStat.avgRecommended / storeStat.productsWithPrices;
				}
			});

			if(reportData.length === 0)
				return;

			// Define columns with appropriate widths
			const columns = Object.keys(reportData[0]).map(key => {
				let width = 15;
				if (key.includes('Title')) width = 30;
				if (key.includes('Price') || key.includes('Cost') || key.includes('MSRP') || key.includes('MAP')) width = 12;
				if (key.includes('SKU') || key.includes('ASIN') || key.includes('UPC')) width = 18;
				if (key.includes('Date')) width = 20;
				if (key.includes('Recommended Price') || key.includes('Min Selling Price') || key.includes('Competitor Price')) width = 14;
				if (key.includes('Pack Qty')) width = 10;
				
				return {
					header: key,
					key: key,
					width: width
				};
			});
	
			// Set the columns
			worksheet.columns = columns;
	
			// Add all rows
			worksheet.addRows(reportData);

			// Add auto-filter
			worksheet.autoFilter = {
				from: { row: 1, column: 1 },
				to: { row: 1, column: Object.keys(reportData[0]).length }
			};

			// Format the main worksheet
			worksheet.eachRow((row, rowNumber) => {
				row.eachCell((cell, colNumber) => {
					const columnHeader = worksheet.getColumn(colNumber).header;
					if (!columnHeader) return;

					// Header row formatting
					if (rowNumber === 1) {
						cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
						cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF4472C4' } };
						cell.alignment = { horizontal: 'center', vertical: 'middle' };
					} else {
						// Data row formatting
						cell.alignment = { horizontal: 'left', vertical: 'middle' };
						
						// Color code store columns
						stores.forEach(st => {
							if(columnHeader.includes(st.name)) {
								cell.fill = {
									type: 'pattern',
									pattern: 'solid',
									fgColor: { argb: 'FF' + newColorPerStoreId[st.id] }
								};
							}
						});

						// Format price columns
						if (columnHeader.includes('Price') || columnHeader.includes('Cost') || columnHeader.includes('MSRP') || columnHeader.includes('MAP')) {
							if (typeof cell.value === 'number') {
								cell.numFmt = '$#,##0.00';
								cell.alignment = { horizontal: 'right' };
							}
						}

						// Format percentage columns
						if (columnHeader.includes('Diff')) {
							if (typeof cell.value === 'number') {
								cell.numFmt = '0.00%';
								cell.alignment = { horizontal: 'right' };
								cell.font = {
									color: { argb: cell.value > 0 ? 'FF2E7D32' : 'FFD32F2F' }
								};
							}
						}
					}
				});
			});
	
			// Freeze first row
			worksheet.views = [
				{ state: 'frozen', xSplit: 0, ySplit: 1 }
			];

			// Create summary worksheet
			summaryWorksheet.columns = [
				{ header: 'Metric', key: 'metric', width: 30 },
				{ header: 'Value', key: 'value', width: 20 }
			];

			const summaryData = [
				{ metric: 'Total Products', value: summaryStats.totalProducts },
				{ metric: 'Products with Prices Found', value: summaryStats.productsWithPrices },
				{ metric: 'Products Not Found Anywhere', value: summaryStats.productsNotFound },
				{ metric: 'Average Min Selling Price', value: summaryStats.avgMinSellingPrice.toFixed(2) },
				{ metric: '', value: '' }, // Empty row
				{ metric: 'Store Statistics', value: '' },
			];

			Object.keys(summaryStats.storeStats).forEach(storeName => {
				const storeStat = summaryStats.storeStats[storeName];
				summaryData.push(
					{ metric: `${storeName} - Products with Prices`, value: storeStat.productsWithPrices },
					{ metric: `${storeName} - Average Price`, value: storeStat.avgPrice.toFixed(2) },
					{ metric: `${storeName} - Average Recommended`, value: storeStat.avgRecommended.toFixed(2) },
					{ metric: `${storeName} - Total Quantity`, value: storeStat.totalQty }
				);
			});

			summaryWorksheet.addRows(summaryData);

			// Format summary worksheet
			summaryWorksheet.eachRow((row, rowNumber) => {
				row.eachCell((cell, colNumber) => {
					if (rowNumber === 1) {
						cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
						cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF4472C4' } };
						cell.alignment = { horizontal: 'center', vertical: 'middle' };
					} else if (rowNumber === 6) { // Store Statistics header
						cell.font = { bold: true };
						cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF2F2F2' } };
					} else {
						cell.alignment = { horizontal: 'left', vertical: 'middle' };
					}
				});
			});

			console.log('Preparing to generate buffer...');

			// Generate the file
			const buffer = await workbook.xlsx.writeBuffer();
				
			// Create a Blob from the buffer
			const blob = new Blob([buffer], {
				type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
			});

			// Create download link and trigger download
			const url = window.URL.createObjectURL(blob);
			const anchor = document.createElement('a');
			anchor.href = url;
			anchor.download = `PMA_Report_${pma.title}_${moment().local().format('YYYY-MM-DD_HH-mm-ss')}.xlsx`;

			// Append to body, click and remove
			document.body.appendChild(anchor);
			anchor.click();
			document.body.removeChild(anchor);

			// Clean up the URL
			window.URL.revokeObjectURL(url);

			props.loading(false);
			
		}catch(e){
			props.loading(false);
			console.error("Excel export error:", e);
			props.info({error: "Failed to export Excel file: " + e.message});
		}
	}

	/* console.info("accountAccepted", accountAccepted);
	console.info("props.accounts", props.accounts);
	console.info("productsproducts", products);
	console.info("pmaDatapmaData", pmaData);
	console.info("props.accounts", props.accounts);
	console.info("isAdmin()isAdmin()", isAdmin());
	console.info("props.parent.match.params", props.parent.match.params);
	console.info("storesstores", stores); */

	let storeIdToTitle = (storeId) => {
		let found = pmaStores.find(s => s.id === storeId);
		return found ? found.title : storeId;
	}

	let hasLineToChange = true
	if(lineAccess.from !== null && lineAccess.from > pmaData.length)
		hasLineToChange = false;
	if(pmaData.length === 0)
		hasLineToChange = false;

	let orderIdStoresHeader = []; // The order should already match but we need to be sure
	
	return (<div>
		{
			isAuthorized()? <div>
				<PMAHeaderInfoResult
					pmaData={pmaData}
					accountAccepted={accountAccepted}
					lineAccess={lineAccess}
					dataNumber={dataNumber}
					dataNumberFilled={dataNumberFilled}
					setPage={setPage}
					pma={pma}
					// currentAccountLines={currentAccountLines}
				/>
				<div className="pb-3 pl-1 pr-1">
					<button className="btn btn-primary" disabled={props.loading()} onClick={() => {
						dlDetails().then(() => {
							console.log("Export completed successfully");
						})
						.catch(error => {
							props.loading(false);
							console.error("Export failed:", error);
							props.info({ error: "Failed to export file" });
						});
					}}>
						{props.loading() ? "Exporting..." : "Export"}
					</button>
				</div>
				{
					pmaStores.length === 0? <div className="alert">
						No stores selected for this PMA, please select some stores <button className="btn btn-primary ml-2" onClick={() => window.history.back()}>Back</button>
					</div> : ""
				}
				{
					isDataLoading? <div style={{height: '100px'}}>
						<Loading loading={true} centered={true}/>
					</div>
					: hasLineToChange? <div className="table-responsive pmaTable" style={{
						position: 'relative',
						height: '60vh'
					}}>
						<div style={{
							position: 'sticky', 
							left: 0, 
							zIndex: 5,
							// borderRight: '2px solid #dee2e6',
							width: '250px'
						}}>
							{
								pmaData.length > 0? <table className="table table-sm table-bordered mb-0 middeSizeText">
									<thead style={{position: 'sticky', top: 0, zIndex: 6}}>
										<tr style={{height: '65px'}}>
										<th className="bg-light text-center align-middle" style={{width: '60px'}}>N</th>
										<th className="bg-light text-center align-middle">SKU</th>
									</tr>
								</thead>
								<tbody>
									{pmaData.map((item, index) => {
										if(lineAccess.from !== null && lineAccess.to !== null && (index+1 < lineAccess.from || index+1 > lineAccess.to))
											return "";
										return <tr key={index} className="sticky-row" data-row-index={index}>
											<td className="text-center align-middle">{item.id}</td>
											<td className="text-center align-middle pointer" onClick={() => {clipboard(item?.sku, props)}}>{item?.sku}</td>
										</tr>
									})}
									</tbody>
								</table> : ""
							}
						</div>
						{
							pmaData.length > 0? 
								<div style={{
									position: 'absolute',
									top: 0,
									left: '250px',
									bottom: 0,
									right: 0,
									overflow: 'none',
									width: 'calc(100% - 250px)',
									height: '90%'
								}}>
									<table className="table table-sm table-bordered mb-0 middeSizeText">
										<thead style={{position: 'sticky', top: 0, zIndex: 4}}>
											<tr style={{height: '65px'}}>
												<th className="bg-light text-center align-middle">Supplier ID</th>
												<th className="bg-light text-center align-middle">UPC/EAN</th>
												<th className="bg-light text-center align-middle">Our min</th>
												<th className="bg-light text-center align-middle">Weight (lbs)</th>
												<th className="bg-light text-center align-middle">Cost</th>
												<th className="bg-light text-center align-middle">Msrp</th>
												<th className="bg-light text-center align-middle">Map</th>
												{stores.map(s => (
													orderIdStoresHeader.push(s.id),
													<th key={s.id} className="bg-light text-center align-middle">
														<div className="d-flex align-items-center justify-content-center">
															{s.name}
															<div 
															style={{
																width: '20px',
																height: '20px',
																borderRadius: '50%',
																backgroundColor: s.color || '#ddd',
																display: 'inline-block',
																marginLeft: '5px'
															}}
														/>
														</div>
													</th>
												))}
												<th className="bg-light text-center align-middle">Created</th>
											</tr>
										</thead>
										<tbody>
											{
												pmaData.map((d, index) => {
													if(lineAccess.from !== null && lineAccess.to !== null && (index+1 < lineAccess.from || index+1 > lineAccess.to))
														return "";

													// Generate store columns for this product
													let storeColumns = stores.map(store => {
														// Find ALL filled price data from d.stores that match this store
														let allFilledStoreInfo = d.stores?.filter(st => {
															return st.id_store_associated_ids?.includes(store.id.toString()) || 
																st.id_pma_stores === store.id;
														}) || [];


														allFilledStoreInfo = allFilledStoreInfo.filter(st => st.price && st.price > 0);

														// Find recommended data from d.recommended
														let recommendedData = d.recommended?.find(rec => rec.id_store === store.id);

														let recommendedPrice = null;
														let prcDiff = null;
														let ourMin = null;
														let color = "";
														let decidedBy = "";

														// Get recommended price from recommended data
														if(recommendedData && recommendedData.recommended_price && recommendedData.recommended_price > 0){
															recommendedPrice = recommendedData.recommended_price;
														}

														// Get min selling price
														if(recommendedData && recommendedData.min_selling_price){
															ourMin = recommendedData.min_selling_price;
															/* if(d?.sku == "WSTP-9567-505"){
																alert(ourMin);
															} */
														} else if(d.minSellingPrice && d.minSellingPrice[store.id]){
															ourMin = d.minSellingPrice[store.id];
														} else if(d.calculated_min_selling_price){
															ourMin = d.calculated_min_selling_price;
														}


														// Calculate price difference
														if(recommendedPrice && ourMin && ourMin > 0){
															prcDiff = ((recommendedPrice - ourMin) / ourMin * 100).toFixed(2);
														}

														// Set color based on price comparison
														if(recommendedPrice && ourMin){
															color = recommendedPrice > ourMin ? "success" : "danger";
														}

														// Set decided by logic
														if(recommendedData && recommendedData.competitor_price){
															decidedBy = "competitor match";
														} else if(allFilledStoreInfo.length > 0){
															decidedBy = "filled price";
														} else if(recommendedPrice){
															decidedBy = "recommended";
														} else {
															decidedBy = "no data";
														}

														/* if(d?.sku == "WSTP-9567-505"){
															alert(allFilledStoreInfo);
														} */

														return <td key={store.id + "_store_line_" + d.id} className="pt-0 pb-0 align-middle middeSizeText">
															<div className="store-info-container">
																<div className={`store-price-info pt-2 pl-2 pr-2 pb-0 pb-1 rounded`}>
																	{/* Only show Price found section if there are associated stores */}
																	{allFilledStoreInfo.length > 0 && (
																		<div>
																			<div className="d-flex justify-content-between">
																				<span className="font-weight-bold">Prices found:</span>
																			</div>
																			{
																					allFilledStoreInfo.map((storeInfo, idx) => {
																						let storeData = getPmaStoreFromId(storeInfo.id_pma_stores);
																						return <div key={idx} className="d-flex justify-content-between small">
																							<span>
																								Store {idx + 1}:
																								<i className="bi bi-info-circle tooltipInfo ml-1" 
																									data-toggle="tooltip" 
																									data-placement="top" 
																									title={storeData.title || "Unknown Store"}
																									data-html="true"
																								></i>
																							</span>
																							<span className="ml-2">{storeInfo.price ? "$" + storeInfo.price : "N/A"}</span>
																						</div>
																				})
																			}
																		</div>
																	)}
																	<div className="d-flex justify-content-between">
																		<span className="font-weight-bold">Recommended:</span>
																		<span className="ml-2">{!recommendedPrice? "N/A" : "$" + roundPrice(recommendedPrice, 2)}</span>
																	</div>
																	{prcDiff && !isNaN(prcDiff) && (
																		<div className="price-difference">
																			<span className={`badge ${prcDiff < 0 ? 'badge-' : 'badge-'}${color}`}>
																				{prcDiff > 0 ? '↑' : '↓'} {Math.abs(prcDiff)}% {prcDiff > 0 ? "higher" : "lower"}
																			</span>
																			<i className="bi bi-info-circle tooltipInfo ml-1" 
																				data-toggle="tooltip" 
																				data-placement="top" 
																				title="From our minimum selling price to the recommended price"
																				data-html="true"
																			></i>
																		</div>
																	)}
																</div>
																
																{/* Show pack qty if any associated store has it */}
																{allFilledStoreInfo.some(st => st.pack_qty) && (
																	<div className="pack-quantity p-1">
																		<div className="d-flex justify-content-between">
																			<span className="font-weight-bold">Pack Qty:</span>
																		</div>
																		{allFilledStoreInfo.map((storeInfo, idx) => {
																				let storeData = getPmaStoreFromId(storeInfo.id_pma_stores);
																				if(storeInfo.pack_qty)
																					return <div key={idx} className="d-flex justify-content-between small">
																						<span>
																							Store {idx + 1}:
																							<i className="bi bi-info-circle tooltipInfo ml-1" 
																								data-toggle="tooltip" 
																								data-placement="top" 
																								title={storeData.title || "Unknown Store"}
																								data-html="true"
																							></i>
																						</span>
																						<span className="ml-2 pointer" onClick={() => {clipboard(storeInfo.pack_qty, props)}}>{storeInfo.pack_qty}</span>
																					</div>
																		})}
																	</div>
																)}
																<div className="recommended-price p-1">
																	<div className="d-flex justify-content-between">
																		<span className="font-weight-bold">
																			Min Price:
																			<i className="bi bi-info-circle tooltipInfo ml-1" 
																				data-toggle="tooltip" 
																				data-placement="top" 
																				title="Minimum selling price for this store"
																				data-html="true"
																			></i>
																		</span>
																		<span className="ml-2 text-primary pointer" onClick={() => {clipboard(ourMin, props)}}>
																			${ourMin? ourMin.toFixed(2) : "N/A"}
																		</span>
																	</div>
																	<div className={(decidedBy? "" : "d-none " ) + "text-center"}>
																		{decidedBy? <span className="ml-2 badge badge-info tooltipInfo" data-original-title="" data-html="true" title='<div>
																				[competitor match] price based on competitor data<br/>
																				[filled price] price found in stores data<br/>
																				[recommended] calculated recommended price<br/>
																				[no data] no pricing data available<br/>
																			</div>'>{decidedBy}</span> : ""}
																	</div>
																</div>
															</div>
														</td>
													});

													return <tr key={index} className="main-row" data-row-index={index}>
														<td className="text-center align-middle pointer" onClick={() => {clipboard(d?.id_supplier1, props)}}>{d?.id_supplier1}</td>
														<td className="text-center align-middle pointer" onClick={() => {clipboard(d?.upc, props)}}>{d?.upc}</td>
														<td className="text-center align-middle text-center">
															<div className="h-100 d-flex flex-column align-content-around justify-content-between">
																{d.avgMin? "AVG: " + d.avgMin.toFixed(3) : ""}
																{
																	Object.keys(d.minSellingPrice || {}).map(storeId => {
																		return <div key={storeId} className="d-flex align-items-center justify-content-between"><img src={storeIconsPerId[storeId]} alt={storeId} style={{width: '20px', height: '20px'}}/> {d.minSellingPrice[storeId]}</div>
																	})
																}
															</div>
														</td>
														<td className="text-center align-middle">{d.static_weight}</td>
														<td className="text-center align-middle">{d.static_cost}</td>
														<td className="text-center align-middle">{d?.msrp > 0? parseFloat(d.msrp).toFixed(2) : ""}</td>
														<td className="text-center align-middle">{d?.map_price > 0? parseFloat(d.map_price).toFixed(2) : ""}</td>
														{storeColumns}
														<td className="text-center align-middle">{d.date_created}</td>
													</tr>
												})
											}
										</tbody>
									</table>
								</div> : <div style={{height: '100px'}}>
										<Loading loading={true} centered={true}/>
								</div>
						}
					</div> : <h4 className="alert d-flex align-items-center justify-content-center">
						No Data available
					</h4>
				}
				<Pagination 
					current_page={page}
					total_items={dataNumber?? 0}
					qtyPerPage={qtyPerPage}
					onUpdatePage={(e, newPage) => setPage(newPage-1)}
					limit_per_page={qtyPerPage}
				/>
			</div>
		: <div className="alert">
				You are not authorized to view this page
			</div>
		}
	</div>);
}
